export default __webpack_public_path__ + "static/media/banner-3.28fe75c9.jpg";